// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

export const LeaveMeeting: React.FC<React.PropsWithChildren<SvgProps>> = (props) => (
  <Svg {...props}>
    <path d="M14.407 5c2.405 0 4.384 1.91 4.495 4.289l.005.211v5c0 2.405-1.91 4.384-4.29 4.495l-.21.005h-2c-1.372 0-2.647-.625-3.498-1.676-.174-.215-.14-.53.074-.704.215-.173.53-.14.703.074.62.765 1.524 1.24 2.509 1.3l.212.006h2c1.86 0 3.394-1.473 3.494-3.309l.006-.191v-5c0-1.86-1.473-3.395-3.31-3.495L14.408 6h-2c-.936 0-1.817.374-2.472 1.029-.195.195-.512.195-.707 0-.195-.196-.195-.513 0-.708.785-.783 1.825-1.255 2.939-1.315l.24-.006h2zM8.682 8.843c.174.173.193.443.058.637l-.058.07-1.976 1.974h6.658c.276 0 .5.224.5.5 0 .246-.177.45-.41.492l-.09.008H6.707L8.682 14.5c.195.195.195.511 0 .707-.174.173-.443.193-.638.058l-.07-.058-2.828-2.83-.013-.013-.032-.038.045.052c-.027-.027-.05-.056-.07-.087l-.02-.035-.019-.041-.006-.016-.007-.019-.008-.03-.005-.02-.006-.032c-.003-.02-.005-.041-.005-.062v-.022c0-.022.002-.043.005-.064L5 12.024c0-.036.004-.071.01-.105l.013-.045c.004-.015.01-.03.016-.044l.006-.014.01-.023.013-.021.007-.012.013-.02.013-.018.032-.038.013-.013 2.829-2.829c.195-.195.512-.195.707 0z" />
  </Svg>
);

LeaveMeeting.displayName = 'LeaveMeeting';

export default LeaveMeeting;
